import SEO from "@/components/SEO";
import AudioPlayer from "@/components/AudioPlayer";
import CTASection from "@/components/CTASection";
import { MaskedLines, FadeUp, SectionTag } from "@/components/Reveal";
import { AUDIO_SAMPLES, IMAGES } from "@/data/content";

const Hoerbeispiele = () => (
  <div data-testid="hoerbeispiele-page">
    <SEO
      title="Hörbeispiele – So klingen unsere Reden & Lieder | Daviz & Puxi"
      description="Hören Sie Mark Daviz und Angela Puxi: Hörbeispiele aus Traureden, Willkommensfeiern und Live-Gesang. Eine Stimme sagt mehr als tausend Worte."
      path="/hoerbeispiele"
    />

    <section className="relative overflow-hidden pb-24 pt-40 sm:pt-52">
      <img src={IMAGES.microphone} alt="Mikrofon in warmem Licht" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-mossdeep/90" />
      <div className="relative mx-auto max-w-5xl px-5 text-center sm:px-8">
        <FadeUp>
          <SectionTag dark>Hörbeispiele</SectionTag>
        </FadeUp>
        <MaskedLines
          lines={["Eine Stimme sagt mehr als", "tausend geschriebene Worte."]}
          className="mt-7 font-serif text-4xl leading-[1.1] text-creme sm:text-6xl"
          delay={0.15}
        />
        <FadeUp delay={0.6}>
          <p className="mx-auto mt-8 max-w-xl leading-relaxed text-creme/75">
            Bevor Sie uns Ihre Zeremonie anvertrauen, dürfen Sie uns zuhören. Diese Ausschnitte
            geben einen ehrlichen Eindruck – von Ton, Tempo und Haltung.
          </p>
        </FadeUp>
      </div>
    </section>

    <section className="mx-auto max-w-4xl px-5 py-20 sm:px-8 sm:py-28">
      <FadeUp className="mb-6">
        <SectionTag>Unsere Stimmen</SectionTag>
        <h2 className="mt-5 font-serif text-3xl sm:text-4xl">Hören Sie selbst</h2>
      </FadeUp>
      <div className="border-t border-sand">
        {AUDIO_SAMPLES.map((a, i) => (
          <FadeUp key={i} delay={Math.min(i * 0.06, 0.3)}>
            <AudioPlayer
              index={i}
              title={a.title}
              speaker={a.speaker}
              duration={a.duration}
              description={a.description}
              src={a.src}
            />
          </FadeUp>
        ))}
      </div>
      <FadeUp className="mt-10">
        <p className="text-center text-sm italic text-stone">
          Hinweis: Weitere Aufnahmen werden derzeit ergänzt und stehen in Kürze zur Verfügung.
          Auf Wunsch senden wir Ihnen gern persönlich ein aktuelles Hörbeispiel zu.
        </p>
      </FadeUp>
    </section>

    <CTASection
      title={["Gefällt Ihnen,", "was Sie hören?"]}
      text="Dann lassen Sie uns sprechen. Am Telefon oder bei einem persönlichen Treffen merken Sie am schnellsten, ob wir zueinander passen."
      buttonLabel="Unverbindlich Kontakt aufnehmen"
    />
  </div>
);

export default Hoerbeispiele;
